
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    MS: "MS",
    SEC: "SEC",
    MIN: "MIN",
    HR: "HR",
    DAY: "DAY",
    WK: "WK",
    MON: "MON",
    QR: "QR",
    YR: "YR"
}
